import { NgModule } from '@angular/core';
import { DxSchedulerModule, DxTemplateModule } from 'devextreme-angular';
import { CoreModule } from '../core/core.module';
import { AccountInformationComponent } from './account/account.component';
import { AdminModule } from './admin/admin.module';
import { CommonModule } from './common/common.module';
import { GeneralModule } from './general/general.module';
import { HistoryModule } from './history/history.module';
import { HomeViewComponent } from './home/home.component';
import { MainViewComponent } from './main.component';
import { NotFoundViewComponent } from './not-found/not-found.component';
import { OdontologyModule } from './odontology/odonto.module';
import { ReportModule } from './report/report.module';

const components = [
  MainViewComponent,
  HomeViewComponent,
  NotFoundViewComponent,
  AccountInformationComponent,
];

@NgModule({
  declarations: [...components],
  imports: [
    CoreModule,
    AdminModule,
    CommonModule,
    HistoryModule,
    GeneralModule,
    OdontologyModule,
    ReportModule,
    DxSchedulerModule,
    DxTemplateModule,
  ],
  exports: [...components],
})
export class MainModule {}
